<template>
  <div>
  <h2>{{ title }}</h2>
  <template>
    <v-system-bar class="branch-data">
      <v-spacer></v-spacer>
      <input-search />
      <circle-button @click.native="createAbout" />
    </v-system-bar>
  </template>
  <template>
    <v-simple-table class="branch-data">
      <template v-slot:default>
        <thead>
        <tr>
          <th class="text-center" v-for="header in headers" :key="header.id">
            {{ header.text }}
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(data, index) in dataTable" :key="data.id">
          <td align="center">{{((dataPaginate.current_page-1)*10)+(index+1)}}</td>
          <td>{{ data.branch ? data.branch.branch_name_th : "" }}</td>
          <td>{{ data.name_th }}</td>
          <td>{{ data.updated_at | moment("DD-MM-YYYY") }}</td>
          <td>{{ data.orders }}</td>
          <td>
            <a @click="showAboutData(data.id)">
              <icon-pencil />
            </a>
          </td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
  </template>
    <paginate :length="dataPaginate.last_page"
              :page="dataPaginate.current_page"
              @update="changePage">
    </paginate>

  </div>
</template>

<script>
import InputSearch from "../../components/Input/InputSearch";
import CircleButton from "../../components/Button/CircleButton";
import IconPencil from "../../components/Icon/icon-pencil";
import Paginate from "../../components/Layout/Paginate";
export default {
  name: "AboutTable",
  components: {Paginate, IconPencil, CircleButton, InputSearch },
  data() {
    return {
      title: "About",
      headers: [
        { id: 1, text: "No." },
        { id: 2, text: "Branch" },
        { id: 3, text: "Name" },
        { id: 4, text: "Update date" },
        { id: 5, text: "Order" },
        { id: 6, text: "Edit" }
      ],
      dataTable: [],
      dataPaginate: {
        current_page: 1,
        from: 1,
        last_page: 1,
        per_page: 1,
        total: 1,
        to: 1
      }
    };
  },
  created() {
    this.getAboutTable(1);
  },
  methods: {
    getAboutTable(page) {
      this.$store.dispatch("About/getAbout", page).then(res => {
        if (res.response_code === 200) {
          this.dataTable = res.result.data;
          this.dataPaginate = {
            current_page: res.result.current_page,
            from: res.result.from,
            last_page: res.result.last_page,
            per_page: res.result.per_page,
            total: res.result.total,
            to: res.result.to
          }
        } else {
          alert(res.response_msg);
        }
      });
    },
    changePage(val){
      this.dataPaginate.current_page = val;
      this.$store.dispatch("About/getAbout", this.dataPaginate.current_page).then(res => {
        if (res.response_code == 200) {
          this.dataTable = res.result.data;
          this.dataPaginate = {
            current_page: res.result.current_page,
            from: res.result.from,
            last_page: res.result.last_page,
            per_page: res.result.per_page,
            total: res.result.total,
            to: res.result.to
          }
        } else {
          alert(res.response_msg);
        }
      });
    },
    goToAboutEdit() {
      this.$router.push("/about/edit");
    },
    showAboutData(id) {
      this.$store.dispatch("About/showAbout", id).then(res => {
        if (res.response_code == 200) {
          this.$store.dispatch("About/setFormAbout", res.result).then(() => {
            this.goToAboutEdit();
          });
        } else {
          alert(res.response_msg);
        }
      });
    },
    createAbout() {
      this.$store.dispatch("About/clearFormData").then(() => {
        this.goToAboutEdit();
      });
    }
  }
};
</script>

<style scoped>
@import "../../assets/css/table.css";
.branch-data {
  background-color: transparent;
  margin: 20px;
}
</style>
